import { render, staticRenderFns } from "./ViewerPDF.vue?vue&type=template&id=96f508ac&"
import script from "./ViewerPDF.vue?vue&type=script&lang=js&"
export * from "./ViewerPDF.vue?vue&type=script&lang=js&"
import style0 from "pdfvuer/dist/pdfvuer.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports